import React from 'react';
import { Grid, Row } from 'react-bootstrap';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/LoginActionsReducers';
import { withRouter } from 'react-router-dom';

import NavMenu from './NavMenu';
import api from '../ApiService';
// https://github.com/fkhadra/react-toastify
import { ToastContainer, Slide } from 'react-toastify';

class Layout extends React.Component {
    componentDidMount = () => {
        this.updateLastLoginDate();
    }

    updateLastLoginDate = () => {
        api.updateLastLoginDate();
        setInterval(() => {
            api.updateLastLoginDate();
        }, 1000 * 60 * 15);
    }
    render() {
        let year = new Date().getFullYear();
        return (
            <Grid fluid>
                <Row>
                    <NavMenu />
                    <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                        {this.props.children}
                    </div>
                </Row>

                <footer className="site-footer align-middle">
                    <span>&copy; {year} iVET360 &middot; All rights reserved.</span>
                    {this.props.isAuthenticated &&
                        <span className="footer-links">
                        <a href="https://ivet360.com/financial-upload" className="plain-link" target="_blank" rel="noopener noreferrer">Financial Upload</a>
                        <a href="https://ivet360.com/pulse/training/" className="plain-link" target="_blank" rel="noopener noreferrer">Training</a>
                        </span>
                    }
                </footer>

                <ToastContainer
                    transition={Slide}
                    position="bottom-center"
                    hideProgressBar
                    autoClose={2000}
                    pauseOnHover
                    closeOnClick
                />
            </Grid >);
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Layout));


// WEBPACK FOOTER //
// ./src/components/Layout.js